import { render, staticRenderFns } from "./TableDataToPdf.vue?vue&type=template&id=60491a4a&scoped=true&"
import script from "./TableDataToPdf.vue?vue&type=script&lang=js&"
export * from "./TableDataToPdf.vue?vue&type=script&lang=js&"
import style0 from "./TableDataToPdf.vue?vue&type=style&index=0&id=60491a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60491a4a",
  null
  
)

export default component.exports